module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/angle-down-dbeb05ef9c2f4987b9852f3d8887d834.svg";